import * as React from 'react';
import * as _ from 'lodash';
import BuildingIndex from '../../components/Buildings/index';
import * as BuildingsApi from '../../api/buildings';

export default class BuildingIndexContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buildings: [],
      pages: 0,
      page: 1,
      isLoading: true,
      where: {
        id: '',
        name: '',
        address: '',
        order: 'name asc',
      },
    };

    this.onPageChange = this.onPageChange.bind(this);
  }

  async onPageChange({ page, ...where }) {
    const { data, headers } = await BuildingsApi.list({
      limit: 10,
      offset: (page - 1) * 10,
      attributes: 'id,name,address,access_types, access_source',
      ...(_.isEmpty(where) ? this.state.where : where),
    });

    const pages = parseInt(headers['x-total-count'], 10);

    this.setState({
      buildings: data,
      pages,
      page,
      where: _.isEmpty(where) ? this.state.where : where,
    });
  }

  async componentDidMount() {
    this.onPageChange({ page: 1 });
  }

  render() {
    return (
      <BuildingIndex
        buildings={this.state.buildings}
        isLoading={this.state.isLoading}
        pages={this.state.pages}
        page={this.state.page}
        onPageChange={this.onPageChange}
      />
    );
  }
}
